// Strips Froala page-break markup (inserted by the page_break plugin as either an <hr class="fr-page-break">
// or a wrapping <div class="fr-page-break">) along with the plain-text "(Page Break)" fallback that some
// export/preview paths substitute in place of the marker.
export function removePageBreaks(html: string): string {
  // Match the whole <hr .../> tag with a single wildcard first (no backtracking ambiguity), then
  // check its class attribute separately. The wildcard excludes both '<' and '>' and is capped
  // at 2000 chars (real tags never have attribute lists anywhere near that long), so a global
  // scan over adversarial input can never cost more than a constant amount of work per starting
  // position, regardless of input length.
  let cleaned = html.replace(/<hr\b[^<>]{0,2000}\/?>/gi, tag =>
    /class=["'][^"']*fr-page-break/i.test(tag) ? '' : tag
  );

  cleaned = cleaned.replace(/<div\b[^<>]{0,2000}>[\s\S]*?<\/div>/gi, block => {
    const openTag = /^<div\b[^<>]{0,2000}>/i.exec(block)?.[0] ?? '';
    return /class=["'][^"']*fr-page-break/i.test(openTag) ? '' : block;
  });

  cleaned = cleaned.replace(/\(Page Break\)/g, '');
  return cleaned;
}
